interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  noIndex?: boolean;
  schema?: object | object[];
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
}

/**
 * SEO component using React 19 document metadata hoisting.
 * <title>, <meta>, and <link> tags are automatically hoisted to <head>.
 * JSON-LD <script> tags are rendered inline (valid per Google spec).
 */
const SEO = ({
  title,
  description,
  canonical,
  noIndex = false,
  schema,
  ogTitle,
  ogDescription,
  ogUrl,
}: SEOProps) => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://dulair.com';
  const resolvedCanonical = canonical ? `${siteUrl}${canonical}` : undefined;

  return (
    <>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {resolvedCanonical && <link rel="canonical" href={resolvedCanonical} />}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {(ogTitle || title) && (
        <meta property="og:title" content={ogTitle || title || ''} />
      )}
      {(ogDescription || description) && (
        <meta property="og:description" content={ogDescription || description || ''} />
      )}
      {(ogUrl || resolvedCanonical) && (
        <meta property="og:url" content={ogUrl || resolvedCanonical || ''} />
      )}
      {schema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              Array.isArray(schema)
                ? { '@context': 'https://schema.org', '@graph': schema }
                : schema
            ),
          }}
        />
      )}
    </>
  );
};

export default SEO;
